import React, { useState } from 'react';
import { useNavigate, Link,useLocation } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useForm } from 'react-hook-form';
import logo from '../../assets/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const BeforeLoginChangePassword = () => {
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const search = useLocation().search;
  const guid = new URLSearchParams(search).get("id");
 const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);

  const onSubmit = (data) => {
    setIsLoading(true);
  
    const payload = {
      Email: data.email,  // Ensure userID is correctly initialized from the appropriate source
      NewPassword: data.newPassword,
      ConfirmPassword: data.confirmPassword,
      OldPassword: data.oldPassword
    };
    console.log(payload);
  
    axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/changepassword`, payload)
      .then(response => {
        setIsLoading(false);
          
        if (response.data.message === 'Password changed successfully') {
          Swal.fire({
            position: 'center',
            icon:'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 3000
          });
          navigate("/login");
        }
       else if (response.data.message === 'Old password is incorrect') {
          Swal.fire({
            position: 'center',
            icon:'success',
            title:'Old password is incorrect' ,
            showConfirmButton: false,
            timer: 3000
          });
        }
      })

      .catch(error => {
        setIsLoading(false);
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Failed to reset password',
          text: error.response?.data?.message || 'An unexpected error occurred',
          showConfirmButton: true,
        });
        console.error('Error resetting password:', error);
      });
  };
  

  return (
    <>
        <section className="vh-100">
        {isLoading ? <div className="spinner"></div> :
          <>
          <Link to="/Login">
           <img
                  src={logo} style={{ height: '60px',  margin: 15 }} alt="Logo"
                />
                </Link>
 <div className="container h-custom">

  <div className="row d-flex justify-content-center align-items-center mt-4">
    <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
      <img
        src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp"
        className="img-fluid"
        alt="Sample" />
    </div>
    <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
      <div className="card shadow-lg p-5" style={{ border: 'none' }}>
      <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="form-outline mb-4">
            <label className="form-label" htmlFor="form3Example3">
              Email address
            </label>
            <input
              type="email"
              id="form3Example3"
              className={`form-control form-control-lg ${errors.email ? 'is-invalid' : ''}`}
              placeholder="Enter a valid email address"
              {...register('email', { 
                required: 'Email is required', 
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: 'Invalid email address'
                }
              })}
            />
            {errors.email && <div className="invalid-feedback">{errors.email.message}</div>}
          </div>
          <div className="form-outline mb-4">
                            <label className="form-label" htmlFor="oldPassword">
                              Old Password
                            </label>
                            <div className="input-group">

                            <input
                               type={showOldPassword ? 'text' : 'password'}
                              id="oldPassword"
                              className={`form-control form-control-lg  border-end-0 ${errors.oldPassword ? 'is-invalid' : ''}`}
                              placeholder="Enter new password"
                              {...register('oldPassword', {
                                required: 'Old password is required',
                              })}
                            />
                                <span
                          className="input-group-text border-start-0"
                          style={{ cursor: 'pointer', backgroundColor: 'transparent' }}
                                  onClick={() => setShowOldPassword(prev => !prev)}
                                >
                                  <FontAwesomeIcon icon={showOldPassword ? faEyeSlash : faEye} />
                                </span>
                          </div>
                          {errors.oldPassword && <div className="invalid-feedback  d-block">{errors.oldPassword.message}</div>}

                          </div>
                          <div className="form-outline mb-4">
                            <label className="form-label" htmlFor="newPassword">
                              New Password
                            </label>
                            <div className="input-group">
                            <input
                               type={showPassword ? 'text' : 'password'}
                              id="newPassword"
                              className={`form-control form-control-lg border-end-0 ${errors.newPassword ? 'is-invalid' : ''}`}
                              placeholder="Enter new password"
                              {...register('newPassword', {
                                required: 'New password is required',
                              })}
                            />
                              <span
                          className="input-group-text border-start-0"
                          style={{ cursor: 'pointer', backgroundColor: 'transparent' }}
                                  onClick={() => setShowPassword(prev => !prev)}
                                >
                                  <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                </span>
                            </div>
                              {errors.newPassword &&  <div className="invalid-feedback d-block">{errors.newPassword.message}</div>}
                          </div>
                          <div className="form-outline mb-4">
                            <label className="form-label" htmlFor="confirmPassword">
                              Confirm Password
                            </label>
                            <div className="input-group">
                            <input
                               type={showConfirmPassword ? 'text' : 'password'}
                              id="confirmPassword"
                              className={`form-control form-control-lg ${errors.confirmPassword ? 'is-invalid' : ''}`}
                              placeholder="Confirm new password"
                              {...register('confirmPassword', {
                                required: 'Confirm password is required',
                              })}
                            />
                          <span
      className="input-group-text border-start-0"
      style={{ cursor: 'pointer', backgroundColor: 'transparent' }}
                                  onClick={() => setShowConfirmPassword(prev => !prev)}
                                >
                                  <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
                                </span>
                          </div>
                          {errors.confirmPassword && <div className="invalid-feedback d-block">{errors.confirmPassword.message}</div>}
                          </div>
                          <div className="text-center d-flex justify-content-between text-lg-start mt-4 pt-2">
                            <button
                              type="submit"
                              className="btn btn-primary"
                              disabled={isSubmitting}
                              style={{ backgroundColor: '#2e3192', borderRadius: 8 }}
                            >
                              Submit
                            </button>
                          </div>
                        </form>

      </div>
    </div>
  </div>
</div>

          </>
        }
      </section>
    </>
  );
};

export default BeforeLoginChangePassword;
